import React,{useState,useContext} from 'react';
import {generateUUID, getToken,getQueryVariable, toMD5withSalt} from '../utils';
import {server} from '../config/serverConfig';
const FullScreenUrl  = function() {




	let uuid =getQueryVariable('uuid');
	let signText =getQueryVariable('signText');

	//验证signText是否有效，如果有效则放行，加载iframe

	if (!uuid || !signText){
		return (
			<div style={{backgroundColor:'yellow'}}>无效请求1</div>
		)

	}

	let checkString = toMD5withSalt(uuid);
	if (checkString !==signText){
		//不相等，返回error
		return (
			<div style={{backgroundColor:'yellow'}}>无效请求2</div>
		)
	}else{

		let url =server.fullScreenPath+'?uuid='+uuid+ '&signText='+signText;


		return (
			<div >
				<iframe src={url}
						style={{marginBottom:'-20px',width:'100%',height:'100vh', frameborder:'no' ,border:'0', marginwidth:'0', marginheight:'0'}}

				></iframe>
			</div>
		);

	}



		

}

export  {FullScreenUrl}
